function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { animated, useSpring } from "@react-spring/web";
import React, { useRef } from "react";
import { useSize } from "ahooks";
import * as mat from "../../utils/matrix";
import { bound } from "../../utils/bound";
import { rubberbandIfOutOfBounds } from "../../utils/rubberband";
import { useDragAndPinch } from "../../utils/use-drag-and-pinch";
var classPrefix = "tc-image-viewer";
export var Slide = function Slide(props) {
  var image = props.image,
    maxZoom = props.maxZoom,
    onTap = props.onTap,
    onZoomChange = props.onZoomChange,
    dragLockRef = props.dragLockRef;
  var controlRef = useRef(null);
  var imgRef = useRef(null);
  var controlSize = useSize(controlRef);
  var imgSize = useSize(imgRef);
  var pinchLockRef = useRef(false);
  var _useSpring = useSpring(function () {
      return {
        matrix: mat.create(),
        config: {
          tension: 200
        }
      };
    }),
    _useSpring2 = _slicedToArray(_useSpring, 2),
    matrix = _useSpring2[0].matrix,
    api = _useSpring2[1];
  var boundMatrix = function boundMatrix(nextMatrix, type) {
    var last = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!controlSize || !imgSize) return nextMatrix;
    var controlLeft = -controlSize.width / 2;
    var controlTop = -controlSize.height / 2;
    var imgLeft = -imgSize.width / 2;
    var imgTop = -imgSize.height / 2;
    var zoom = mat.getScaleX(nextMatrix);
    var scaledImgWidth = zoom * imgSize.width;
    var scaledImgHeight = zoom * imgSize.height;
    var _mat$apply = mat.apply(nextMatrix, [imgLeft, imgTop]),
      _mat$apply2 = _slicedToArray(_mat$apply, 2),
      x = _mat$apply2[0],
      y = _mat$apply2[1];
    if (type === "translate") {
      var boundedX = x;
      var boundedY = y;
      if (scaledImgWidth > controlSize.width) {
        var minX = controlLeft - (scaledImgWidth - controlSize.width);
        var maxX = controlLeft;
        boundedX = last ? bound(x, minX, maxX) : rubberbandIfOutOfBounds(x, minX, maxX, zoom * 50);
      } else {
        boundedX = -scaledImgWidth / 2;
      }
      if (scaledImgHeight > controlSize.height) {
        var minY = controlTop - (scaledImgHeight - controlSize.height);
        var maxY = controlTop;
        boundedY = last ? bound(y, minY, maxY) : rubberbandIfOutOfBounds(y, minY, maxY, zoom * 50);
      } else {
        boundedY = -scaledImgHeight / 2;
      }
      return mat.translate(nextMatrix, boundedX - x, boundedY - y);
    }
    if (type === "scale" && last) {
      var _boundedX = scaledImgWidth > controlSize.width ? bound(x, controlLeft - (scaledImgWidth - controlSize.width), controlLeft) : -scaledImgWidth / 2,
        _boundedY = scaledImgHeight > controlSize.height ? bound(y, controlTop - (scaledImgHeight - controlSize.height), controlTop) : -scaledImgHeight / 2;
      return mat.translate(nextMatrix, _boundedX - x, _boundedY - y);
    }
    return nextMatrix;
  };
  useDragAndPinch({
    onDrag: function onDrag(state) {
      if (state.first) return;
      if (state.pinching) return state.cancel();
      if (state.tap && state.elapsedTime > 0 && state.elapsedTime < 1000) {
        // 判断点击时间>0是为了过滤掉非正常操作，例如用户长按选择图片之后的取消操作（也是一次点击）
        onTap();
        return;
      }
      var currentZoom = mat.getScaleX(matrix.get());
      if (dragLockRef) {
        dragLockRef.current = currentZoom !== 1;
      }
      if (!pinchLockRef.current && currentZoom <= 1) {
        api.start({
          matrix: mat.create()
        });
      } else {
        var currentMatrix = matrix.get();
        var offset = [state.offset[0] - mat.getTranslateX(currentMatrix), state.offset[1] - mat.getTranslateY(currentMatrix)];
        var nextMatrix = mat.translate.apply(mat, [currentMatrix].concat(_toConsumableArray(state.last ? [offset[0] + state.velocity[0] * state.direction[0] * 200, offset[1] + state.velocity[1] * state.direction[1] * 200] : offset)));
        api.start({
          matrix: boundMatrix(nextMatrix, "translate", state.last),
          immediate: !state.last
        });
      }
    },
    onPinch: function onPinch(state) {
      pinchLockRef.current = !state.last;
      var _state$offset = _slicedToArray(state.offset, 1),
        d = _state$offset[0];
      if (d < 0) return;
      var mergedMaxZoom;
      if (maxZoom === "auto") {
        mergedMaxZoom = controlSize && imgSize ? Math.max(controlSize.height / imgSize.height, controlSize.width / imgSize.width) : 1;
      } else {
        mergedMaxZoom = maxZoom;
      }
      var nextZoom = state.last ? bound(d, 1, mergedMaxZoom) : d;
      onZoomChange === null || onZoomChange === void 0 ? void 0 : onZoomChange(nextZoom);
      if (state.last && nextZoom <= 1) {
        api.start({
          matrix: mat.create()
        });
        if (dragLockRef) {
          dragLockRef.current = false;
        }
      } else {
        if (!controlSize) return;
        var currentMatrix = matrix.get();
        var currentZoom = mat.getScaleX(currentMatrix);
        var originOffsetX = state.origin[0] - controlSize.width / 2;
        var originOffsetY = state.origin[1] - controlSize.height / 2;
        var nextMatrix = mat.translate(currentMatrix, -originOffsetX, -originOffsetY);
        nextMatrix = mat.scale(nextMatrix, nextZoom / currentZoom);
        nextMatrix = mat.translate(nextMatrix, originOffsetX, originOffsetY);
        api.start({
          matrix: boundMatrix(nextMatrix, "scale", state.last),
          immediate: !state.last
        });
        if (dragLockRef) {
          dragLockRef.current = true;
        }
      }
    }
  }, {
    target: controlRef,
    drag: {
      // filterTaps: true,
      from: function from() {
        return [mat.getTranslateX(matrix.get()), mat.getTranslateY(matrix.get())];
      },
      pointer: {
        touch: true
      }
    },
    pinch: {
      from: function from() {
        return [mat.getScaleX(matrix.get()), 0];
      },
      pointer: {
        touch: true
      }
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-slide"),
    onPointerMove: function onPointerMove(e) {
      if (mat.getScaleX(matrix.get()) !== 1) {
        e.stopPropagation();
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-control"),
    ref: controlRef
  }, /*#__PURE__*/React.createElement(animated.div, {
    className: "".concat(classPrefix, "-image-wrapper"),
    style: {
      matrix: matrix
    }
  }, /*#__PURE__*/React.createElement("img", {
    ref: imgRef,
    src: image,
    draggable: false,
    alt: image
  }))));
};